







import { Component, Vue, Prop } from 'vue-property-decorator';
import SalesProjectsList from '@/components/SalesProjectsList.vue';
import NotLoggedPanel from '@/components/NotLoggedPanel.vue';
import { User } from '@/models/user';

@Component({
    name: 'SalesProjects',
    components: {
        SalesProjectsList,
        NotLoggedPanel
    }
})
export default class SalesProjects extends Vue {
    @Prop() private user!: User;
}
